import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Resolve a media reference (relative /api/... path or absolute url) to a full URL.
export const mediaUrl = (ref) => {
  if (!ref) return "";
  if (ref.startsWith("http")) return ref;
  if (ref.startsWith("/api/")) return `${BACKEND_URL}${ref}`;
  return ref;
};

export const BRAND = {
  logo: "https://static.prod-images.emergentagent.com/jobs/cfe3ab0d-e6a2-471a-aeec-9e4b994e5275/images/4b6fbed16ff58b0b86e58021aeae45ec30af2e12b66553c1a0d461828c994c58.jpeg",
  hero: "https://static.prod-images.emergentagent.com/jobs/cfe3ab0d-e6a2-471a-aeec-9e4b994e5275/images/5e7832fa02c4af2d47e4ef7aca4a597a683ca9fb573e2f57d5b198797f4e35bc.jpeg",
};

export const CONTENT_TYPE_LABELS = {
  berita_kegiatan: "Berita Kegiatan",
  edukasi: "Edukasi",
  pengumuman: "Pengumuman",
  data_informasi: "Data & Informasi",
};

const BULAN = ["Januari", "Februari", "Maret", "April", "Mei", "Juni", "Juli", "Agustus", "September", "Oktober", "November", "Desember"];

// Format an ISO date to WIT (Asia/Jayapura, UTC+9).
export const formatWIT = (iso, withTime = false) => {
  if (!iso) return "-";
  try {
    const d = new Date(iso);
    const parts = new Intl.DateTimeFormat("id-ID", {
      timeZone: "Asia/Jayapura", day: "numeric", month: "numeric", year: "numeric",
      ...(withTime ? { hour: "2-digit", minute: "2-digit" } : {}),
    }).formatToParts(d);
    const get = (t) => parts.find((p) => p.type === t)?.value;
    const day = get("day");
    const month = BULAN[parseInt(get("month"), 10) - 1];
    const year = get("year");
    let s = `${day} ${month} ${year}`;
    if (withTime) s += ` ${get("hour")}.${get("minute")}`;
    return `${s} WIT`;
  } catch {
    return iso;
  }
};
